// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"01a11926","329":"9d145244","655":"b095cf1c"}[chunkId] + ".chunk.css";
};